import { render } from "./portfolio-gallery.vue?vue&type=template&id=fab0c492&scoped=true&ts=true"
import script from "./portfolio-gallery.vue?vue&type=script&lang=ts"
export * from "./portfolio-gallery.vue?vue&type=script&lang=ts"

import "./portfolio-gallery.vue?vue&type=style&index=0&id=fab0c492&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab0c492"]])

export default __exports__